module.exports = __webpack_public_path__ + "img/Stan-Head_sm.37c4ca50.jpg";